import { Badge, type BadgeColor } from '@civilgrid/ui/components';
import { requestTypeMap } from '~/common/dataRequestUtils';
import { RequestType } from '~/common/types';

const typeConfig: Record<string, BadgeColor> = {
  [requestTypeMap[RequestType.MapsRequested]]: 'green',
  [requestTypeMap[RequestType.AsbuiltsRequested]]: 'pink',
};

interface Props {
  type: RequestType;
}

export default function ({ type }: Props) {
  if (!type) return null;
  const color = typeConfig[type] || 'grey';

  return (
    <div className="flex w-full items-center justify-start">
      <Badge color={color}>
        <span className="truncate">{type}</span>
      </Badge>
    </div>
  );
}
